import React from "react";

import Chip from "@material-ui/core/Chip";
import CardContent from '@mui/material/CardContent';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "left",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
    // padding: 5,
  },
}));

const PostTags = ({ tags }) => {
  const classes = useStyles();
  const handleClick = (tag) => {
    window.location.href = `/memory?tags=${tag.name}`;
  };

  return (
    <div >
      {tags && tags.length !== 0 ? (
        <CardContent className={classes.root}>
          {tags.map((tag) => (
            <Chip
              variant="outlined"
              size="small"
              label={tag.name}
              onClick={() => handleClick(tag)}
              key={tag.id}
            />
          ))}
        </CardContent>
      ) : (
        <div />
      )}
    </div>
  );
};

export default PostTags;
